import type { CategoryMap } from '../lib/types';

const CATEGORIES: Array<{ key: keyof CategoryMap; label: string; icon: string }> = [
  { key: '全体運', label: '全体運', icon: '◎' },
  { key: '人間関係', label: '人間関係', icon: '人' },
  { key: '仕事', label: '仕事', icon: '事' },
  { key: '金運', label: '金運', icon: '財' },
  { key: '健康運', label: '健康', icon: '康' },
];

interface Props {
  categories: CategoryMap;
}

export function CategoryGrid({ categories }: Props) {
  return (
    <dl className="mt-4 space-y-3">
      {CATEGORIES.map((c) => (
        <div key={c.key} className="flex gap-3">
          <dt className="shrink-0 w-12 text-center">
            <div className="font-serif text-base text-gold-500" aria-hidden>{c.icon}</div>
            <div className="text-[11px] text-ink-500 dark:text-ink-300 mt-0.5">{c.label}</div>
          </dt>
          <dd className="flex-1 text-sm leading-relaxed text-ink-700 dark:text-ink-200">
            {categories[c.key] || <span className="text-ink-300 dark:text-ink-500">—</span>}
          </dd>
        </div>
      ))}
    </dl>
  );
}
